export default "__VITE_ASSET__hLZm8Nsr__"